module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.ttf?aff2223d91d354eb721f3c9dd35b78ff";